import Swiper, { Pagination, Autoplay, EffectFade, Navigation } from "swiper";
import gsap from "gsap";
Swiper.use([Pagination, Autoplay, EffectFade, Navigation]);

class MainSlider {
    constructor (el) {
        this.el = el;
        this.slider = null;
        this.slides = this.el.querySelectorAll('.swiper-slide')
        this.current = this.el.querySelector('.js-counter-current')
        this.total = this.el.querySelector('.js-counter-total')
        this.next = this.el.querySelector('.m-slider__btn--next')
        this.prev = this.el.querySelector('.m-slider__btn--prev')
        this.autoplayHandler = () => this.autoplay()

        this.tween = null
        
        this.initDefault();
    }

    initDefault () {
        if (this.slides.length <= 1) {
            this.el.classList.add('hide-controls')
        }
        this.initEvents();
        this.initSLider();
    }

    initEvents () {

    }

    initSLider () {
        this.slider = new Swiper(this.el, {
            simulateTouch: true,
            watchSlidesVisibility: true,
            autoHeight: false,
            effect: 'fade',
            crossFade: true,
            followFinger: true,
            loop: true,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            navigation: {
              prevEl: this.prev,
              nextEl: this.next
            },
            pagination: {
                el: ".swiper-pagination",
                bulletClass: "m-slider__pagination-container",
                bulletActiveClass: "active",
                clickable: true,
                renderBullet: function (index, className) {
                    return "<span class=\""+ className +"\">" + 
        "<span class=\"m-slider__progress\">" +
        "<span class=\"m-slider__progress-bar\"></span>" +
        "</span>" +
        "<span class=\"m-slider__pagination-dot\"></span>" +
        "</span>";
                }
            },
            on: {
                afterInit: () => {
                  this.autoplay();
                },
                slideChange: () => {
                  this.autoplay();
                }
            }
        });
    }
    
    autoplay () {
      if (this.slides.length <= 1) return;
      const item = document.querySelector('.m-slider__pagination-container.active')

      if (!item) return;

      if (this.tween) {
        this.tween.kill()
        this.tween = null
      }
      
      const progress = item.querySelector('.m-slider__progress-bar')

      this.tween = gsap.fromTo(progress, 
        {
          x: 0
        },
        {
          duration: 7,
          x: '100%',
          ease: 'ease',
          onComplete: () => {
            this.slider.slideNext();
          }
        })

    }
}

window.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector(".js-m-slider");
  if ( el ) {
    new MainSlider(el);
  }
});